import React from 'react';
import Translate from 'react-translate-component';

import { salaryIntervalTemplate, getValueFromDictBy } from 'helpers/fieldsHelpers';
import { notEmpty } from 'utils/ramdaAdditions';

const salaryTypes = {
    1: 'request.gross',
    2: 'request.net'
};

const getCurrency = getValueFromDictBy('id', 'code');
const getSalaryDescription = ({ currency, type }, dictionary) => {
    const currencyStr = getCurrency(currency, dictionary, '');
    const salaryType = salaryTypes[type];

    return (
        <span>
            { currencyStr }
            { salaryType && (
                <span> (<Translate content={salaryType} />)</span>
            )}
        </span>
    );
};

const getSalary = ({ amount }) => salaryIntervalTemplate(amount.from, amount.to);

const RequestSalary = ({ salary, options }) => salary && notEmpty(options) ? (
    <span>
        { getSalary(salary) }
        { " " }
        { getSalaryDescription(salary, options) }
    </span>
) : null;

export default RequestSalary;
